import classes from './Spacer.module.css.mjs';

const spacerSizeClasses = {
  none: classes.spacerSizeNone,
  xs: classes.spacerSizeXS,
  s: classes.spacerSizeS,
  m: classes.spacerSizeM,
  l: classes.spacerSizeL,
  xl: classes.spacerSizeXL
};

export { spacerSizeClasses };
